
export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CEO 인사말 */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 md:mb-24">
          {/* Left - Logo & CEO */}
          <div className="space-y-6 md:space-y-8">
            <div className="flex items-center gap-3 md:gap-4">
              <img
                src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/b0216ecd9824ced9791064a8a701a53c.png"
                alt="ROBO Asset Grid Logo"
                className="h-12 md:h-16 w-auto"
              />
              <div>
                <p className="text-sm md:text-base text-gray-500 font-semibold">About</p>
                <h2 className="text-2xl md:text-4xl font-black text-gray-900">
                  ROBO Asset Grid
                </h2>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-5 md:p-8 border border-teal-100">
              <p className="text-sm md:text-lg text-gray-700 font-medium leading-relaxed mb-4">
                안녕하세요.<br />
                (주)로보에셋그리드 대표이사 이동우입니다.
              </p>
              <p className="text-sm md:text-lg text-gray-700 font-medium leading-relaxed mb-4">
                당사는 탄소 제로(Carbon-free), 연결(Connected), 소비자(Consumer)의{' '}
                <strong className="text-teal-700 font-bold">3C를 핵심 비전</strong>으로 삼아
                설립된 스마트 수도미터 제조/생산/유통 전문 기업입니다.
              </p>
              <p className="text-sm md:text-lg text-gray-700 font-medium leading-relaxed mb-4">
                당사의 &lsquo;스마트 광센서 수도미터기(계량기)&rsquo;를 통해 가정은
                물론 상업, 오피스 등에서 수도 요금을 대폭 절감할 수 있게 될 것이며,
                사물인터넷(IoT)과 연계되어 에너지(데이터)의 수집, 처리, 교환이
                가능해집니다.
              </p>
              <p className="text-sm md:text-lg text-gray-700 font-medium leading-relaxed mb-6">
                이러한 정보는 클라우드 시스템에 저장되며 &ldquo;에너지 절약(Saving)&rdquo;
                에 활용되어 환경을 보호하고, 이를 통해 탄소 제로 사회를 실현하며,
                동시에 유틸리티(가스, 전기, 수도) 인프라가 없거나 부족한 미개발 국가 및
                지역에 안정적으로 국민이 누려야 할 기본 인프라를 제공하게 될
                것입니다.
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-teal-200">
                <div>
                  <p className="text-base md:text-xl font-bold text-gray-900 italic">
                    Lee Dong-Woo
                  </p>
                  <p className="text-xs md:text-base text-gray-500 font-medium">대표이사 이동우</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Product Showcase */}
          <div className="space-y-6 md:space-y-8">
            <div className="relative bg-gradient-to-br from-[#0a3d4f] to-[#0a2e3d] rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-10 overflow-hidden">
              <div className="absolute top-0 right-0 w-40 h-40 bg-teal-400/10 rounded-full blur-[60px]"></div>
              <div className="relative w-full h-[220px] sm:h-[300px] md:h-[400px] flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/3bb60e1413457df40dbc6ee39e0447f8.png"
                  alt="광센서 스마트 디지털 수도미터"
                  title="로보에셋그리드 광학센싱 스마트 디지털 수도미터기 제품"
                  className="w-full h-full object-contain drop-shadow-2xl"
                />
              </div>
              <div className="mt-4 md:mt-6 grid grid-cols-3 gap-3 md:gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center">
                  <div className="text-xl md:text-3xl font-black text-teal-400">
                    3C
                  </div>
                  <div className="text-[10px] md:text-sm text-white/70 font-medium mt-1">
                    핵심 비전
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center">
                  <div className="text-xl md:text-3xl font-black text-teal-400">
                    IoT
                  </div>
                  <div className="text-[10px] md:text-sm text-white/70 font-medium mt-1">
                    실시간 연동
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center">
                  <div className="text-xl md:text-3xl font-black text-teal-400">
                    0%
                  </div>
                  <div className="text-[10px] md:text-sm text-white/70 font-medium mt-1">
                    납 성분
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 사업 구성도 */}
        <div className="bg-gradient-to-br from-gray-50 to-teal-50/30 rounded-2xl p-5 md:p-8 lg:p-12">
          <div className="text-center mb-8 md:mb-12">
            <div className="inline-block px-4 py-2 bg-teal-50 rounded-full mb-4">
              <span className="text-teal-600 text-sm md:text-base font-bold">
                Business Composition
              </span>
            </div>
            <h3 className="text-2xl md:text-4xl font-black text-gray-900">
              사업 구성 계획
            </h3>
          </div>

          {/* Diagram Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-settings-3-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                오토메이션
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                자동화된 수도 계량 및 관리 시스템
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-fire-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                광센서 가스계량기
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                통합 가스 계량 관리 솔루션
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-wifi-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                IoT 연계 시스템
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                사물인터넷 기반 실시간 모니터링
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-dashboard-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                디지털 관리 서비스
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                클라우드 기반 통합 관리 플랫폼
              </p>
            </div>
          </div>

          {/* Flow Diagram */}
          <div className="mt-8 md:mt-12 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4">
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-center text-base md:text-lg whitespace-nowrap w-full md:w-auto">
              스마트 계량기
            </div>
            <i className="ri-arrow-down-line md:hidden text-2xl text-teal-600"></i>
            <i className="ri-arrow-right-line text-2xl text-teal-600 hidden md:block"></i>
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-center text-base md:text-lg whitespace-nowrap w-full md:w-auto">
              IoT 데이터 수집
            </div>
            <i className="ri-arrow-down-line md:hidden text-2xl text-teal-600"></i>
            <i className="ri-arrow-right-line text-2xl text-teal-600 hidden md:block"></i>
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-center text-base md:text-lg whitespace-nowrap w-full md:w-auto">
              클라우드 분석
            </div>
            <i className="ri-arrow-down-line md:hidden text-2xl text-teal-600"></i>
            <i className="ri-arrow-right-line text-2xl text-teal-600 hidden md:block"></i>
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-center text-base md:text-lg whitespace-nowrap w-full md:w-auto">
              에너지 절약
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="text-center">
            <div className="w-14 md:w-16 h-14 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-shield-check-line text-2xl md:text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg md:text-2xl font-bold text-gray-900 mb-2">
              안전성
            </h4>
            <p className="text-sm md:text-lg text-gray-600 font-medium">
              납 성분 없는 스테인리스 재질로 안전한 수도 계량을 보장합니다
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 md:w-16 h-14 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-line-chart-line text-2xl md:text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg md:text-2xl font-bold text-gray-900 mb-2">
              정확성
            </h4>
            <p className="text-sm md:text-lg text-gray-600 font-medium">
              광학 센싱 기술로 정밀한 계량과 부정사용 방지를 실현합니다
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 md:w-16 h-14 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-global-line text-2xl md:text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg md:text-2xl font-bold text-gray-900 mb-2">
              확장성
            </h4>
            <p className="text-sm md:text-lg text-gray-600 font-medium">
              IoT 연계로 스마트시티 인프라와 완벽하게 통합됩니다
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
